<template>
  <div
    v-if="isActive && getCheckBotKks()?.length"
    class="check-bot-established-kks-panel"
  >
    <check-bot-established-kks
      :is-validating-kks="isValidatingKks"
      :kks-list="getCheckBotKks()"
      :kks-validation-list="kksValidationList"
      @kks-clicked="moveOneCheckBotEstablishedKksToMainKksField"
    >
    </check-bot-established-kks>
    <div
      :class="{
        'copy-kks-buttons': true,
        busy: isCopyingKks,
      }"
    >
      <PVButton
        :size="'small'"
        @click="() => moveCheckBotEstablishedKksNumbersToMainKksField(true)"
        >{{ $t('documentDetailView.copyValidatedKks') }}</PVButton
      >
      <PVButton
        :size="'small'"
        @click="() => moveCheckBotEstablishedKksNumbersToMainKksField(false)"
        >{{ $t('documentDetailView.copyCheckBotKks') }}</PVButton
      >
    </div>
  </div>
</template>

<script src="./CheckBotEstablishedKksPanel.script.ts" lang="ts" />
<style src="./CheckBotEstablishedKksPanel.style.scss" lang="scss" scoped />
